import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React from 'react';

export default function AllServicesHero() {
  return (
    <>
      <Breadcrumb items={[{ label: 'خانه', to: '/' }, { label: 'خدمات' }]} position="center" />
      <SectionHead
        tag={'خدمات'}
        title={'خدمات کارا؛ سرعت و دقت در دسترس شما'}
        text="در دنیای امروز که همه‌چیز به سرعت در حال تغییر است، ما در کارا تصمیم داریم تا تجربه‌ای متفاوت از خدمات خودرویی به شما ارائه بدیم. خدمات ما از استعلام خلافی خودرو گرفته تا دسترسی به تاریخچه پلاک، همه در یک پلتفرم ساده و قابل دسترس به شما ارائه میشه. هیچ نیازی به مراجعه حضوری یا جستجوهای طولانی نیست، تنها با یک کلیک می‌تونید اطلاعات مورد نیاز خود رو در سریع‌ترین زمان ممکن دریافت کنید."
        headingTag="h1"
        type="otherPages"
        position={'center'}
      />
    </>
  );
}
